export enum MarketplaceEngagementTimelineSubTab {
    ProcessView = 1,
    GanttChartView = 2,
    CalendarView = 3,
}

export const MarketplaceEngagementTimelineSubTabs = [
    {
        id: MarketplaceEngagementTimelineSubTab.ProcessView,
        content: 'Process View',
    },
    {
        id: MarketplaceEngagementTimelineSubTab.GanttChartView,
        content: 'Gantt Chart View',
    },
    {
        id: MarketplaceEngagementTimelineSubTab.CalendarView,
        content: 'Calendar View',
    },
];
